import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { Button } from '../../components';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../constants/appRoutes';
import Image404 from '../../assets/img404.png';

const NotFoundPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClick = () => navigate(APP_ROUTES.MAIN_PAGE);

  return (
    <div className={styles.notFoundPage}>
      <div className={styles.wrapperContent}>
        <div className={styles.container}>
          <h1 className={styles.title}>404</h1>
          <span className={styles.subtitle}>{t('Page not found')}</span>
        </div>
        <div className={styles.wrapperImg}>
          <img src={Image404} alt="bg 404" />
        </div>
        <div className={styles.container}>
          <p className={styles.text}>
            {t(
              'Something went wrong, we are working on it. Please, go to the main page.',
            )}
          </p>
          <Button text={'To the Main page'} onClick={onClick} />
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
